import { getOrderDetails, cancelOrder, fetchcancelDelivery } from '@fetch/order';
import { fetchGoodsTags } from '@fetch';
import { orderStatus, deliveryStatus, paymentOrRefundStatus } from '@utils/config/order';

const state = {
  orderInfo: {}, //订单配送相关信息
  deliveryList: [], //配送商品信息
  settleAccountInfo: {}, // 所有仓库合计
  paymentList: [], // 支付明细
  refundList: [], // 退款明细
  isModifyAddress: false, // 详情页是否可以修改地址
  timesCardPayment: false, // 默认不是次卡支付
  goodsChangingOrRefunding: false, // 默认不是退换货
};

const getters = {
  getSettleAccountInfo: state => {
    let totalNums = 0,
      totalAmount = 0,
      totalGoodsPrice = 0,
      totalFreight = 0,
      reducePrice = 0;

    state.deliveryList.map(deliveryItem => {
      totalNums += Number(deliveryItem.goodsNum);
      totalGoodsPrice += Number(deliveryItem.totalPrice);
      totalFreight += Number(deliveryItem.freight);
      totalAmount += Number(deliveryItem.totalAmount);
      reducePrice += Number(deliveryItem.reducePrice);
    });

    return {
      totalAmount: Number(totalAmount).toFixed(2),
      totalNums,
      totalFreight: Number(totalFreight).toFixed(2),
      totalGoodsPrice: Number(totalGoodsPrice).toFixed(2),
      reducePrice: reducePrice ? Number(reducePrice).toFixed(2) : 0,
    };
  },
};

const actions = {
  getOrderDetailInfo({ commit }, data) {
    getOrderDetails(data).then(res => {
      if (res.code) return;
      let goodsList = [];
      if (res.deliveryList && res.deliveryList.length > 0) {
        res.deliveryList.forEach(item => {
          item.goodsList.forEach(goods => {
            if (goods.goodsId && goods.categoryId) {
              goodsList.push({ goodsId: goods.goodsId, categoryId: goods.categoryId })
            }
          })
        })
        try {
          fetchGoodsTags({ goodsList, channel: 2 }).then(tagRes => {
            if (tagRes && tagRes.length > 0) {
              res.deliveryList.forEach(item => {
                item.goodsList.forEach(goods => {
                  const goodTag = tagRes.find(tag => tag.categoryId == goods.categoryId && tag.goodsId == goods.goodsId);
                  let tags = goodTag && goodTag.tags ? goodTag.tags : [];
                  // 爆炸贴数据
                  let stickerImgList = tags.filter(item => item.type === 2);
                  goods.stickerImgList = stickerImgList;
                  goods.tags = tags;
                })
              });
              commit('setOrderInfo', res);
              commit('setDeliveryList', res);
              commit('setPaymentList', res);
              commit('setRefundList', res);
            }else{
              commit('setOrderInfo', res);
              commit('setDeliveryList', res);
              commit('setPaymentList', res);
              commit('setRefundList', res);
            }
          })
        } catch (error) {
          commit('setOrderInfo', res);
          commit('setDeliveryList', res);
          commit('setPaymentList', res);
          commit('setRefundList', res);
        }
      }
    });
  },
  onCancelOrder(undefined, data) {
    cancelOrder(data).then(res => {
      if (data.success && data.error)
        res ? data.success() : data.error();
    });
  },
  cancelDelivery(undefined, data) {
    return fetchcancelDelivery(data);
  },
};

const mutations = {
  setOrderInfo(state, res) {
    const { orderInfo} = res;

    // ui 层需要根据订单状态配置的
    const extraOrderInfo = orderStatus.filter(
      item => item.status === orderInfo.orderStatus,
    )[0];

    if (extraOrderInfo.status === 4) { // 取消订单的文案从接口中取
      extraOrderInfo.description = orderInfo.orderSubStatusDesc;
    }

    const { timeCardPackage, businessType, threeMerchant } = orderInfo;

    state.timesCardPayment = timeCardPackage;
    state.goodsChangingOrRefunding = (businessType > 1), // 1，普通订单2，换货3，补发
    state.threeMerchant = threeMerchant, // API商家：京东/菠萝派/管易云

    state.orderInfo = {
      delete: res.delete,
      orderAllRefund: res.orderAllRefund,
      ...orderInfo,
      ...extraOrderInfo, // 订单信息的 ui 样式类
    };
  },

  setDeliveryList(state, { deliveryList, orderInfo }) {
    const { businessType, threeMerchant } = orderInfo;
    deliveryList = deliveryList || []; // 容错处理
    state.needPayment = '';
    // 换货补发不可以修改地址
    state.isModifyAddress = deliveryList.every(item => item.deliveryOrderStatus <= 3) && businessType < 2 && !threeMerchant;
    state.deliveryList = deliveryList.map(deliveryParcelItem => {
      let itemDeliveryStatus = deliveryStatus.filter(
        item => item.status === deliveryParcelItem.deliveryOrderStatus,
      )[0];
      deliveryParcelItem.goodsList.map(goodsItem => {
        goodsItem.totalPrice = (
          Number(goodsItem.goodsPrice) * Number(goodsItem.quantity)
        ).toFixed(2);
        goodsItem.goodsPrice = Number(goodsItem.goodsPrice).toFixed(2);
      });

      deliveryParcelItem.totalAmount = Number(
        deliveryParcelItem.totalAmount,
      ).toFixed(2);

      return {
        ...deliveryParcelItem,
        ...itemDeliveryStatus,
      };
    });
  },

  setPaymentList(state, { paymentList }) {
    paymentList = paymentList || [];
    state.paymentList = paymentList.map(paymentItem => {
      let item = paymentOrRefundStatus.filter(statusItem => statusItem.status === paymentItem.payWay)[0];
      return {...paymentItem, ...item};
    });
  },

  setRefundList(state, { refundList }) {
    refundList = refundList || [];
    state.refundList = refundList.map(refundItem => {
      let item = paymentOrRefundStatus.filter(statusItem => statusItem.status === refundItem.refundWay)[0];
      return { ...refundItem, ...item };
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
